<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="post-title-section">
        <PillList v-if="tags" :pills="tags" no-scroll class="post-title-section__tags" />
        <h1 class="post-title-section__title" v-html="title" />
        <div class="post-title-section__under-title">
            <img :src="author.image" alt="authorImage" class="post-title-section__author-image" />
            <div>
                <span class="post-title-section__author-name">{{ author.name }}</span
                ><span v-if="date">, {{ date }}</span
                ><span v-if="readTime" class="post-title-section__read-time">, {{ formattedReadTime }}</span>

                <div v-if="readTime" class="post-title-section__read-time--mobile">{{ formattedReadTime }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import PillList from '~/components/PillList.vue';

export default {
    name: 'PostTitleSection',
    components: {
        PillList,
    },
    props: {
        tags: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: '',
        },
        author: {
            type: Object,
            default: () => ({}),
        },
        date: {
            type: String,
            default: '',
        },
        readTime: {
            type: [String, Number],
            default: '',
        },
    },
    computed: {
        formattedReadTime() {
            return this.$t('magazine.reading_time', { minutes: this.readTime });
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.post-title-section {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__tags {
        margin-bottom: $md-magazine-spacing;
    }

    &__title {
        @extend %heading-1;
        text-align: center;
    }

    &__under-title {
        display: flex;
        align-items: center;
        @include font-size(13px);
        margin-top: $md-magazine-spacing;
    }

    &__author-image {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 12px;
        object-fit: cover;
    }

    &__author-name {
        font-weight: bold;
    }

    &__read-time {
        display: none;
        @include font-size(13px);

        @include lg {
            display: inline-block;
        }

        &--mobile {
            width: 100%;
            @include font-size(12px);
            margin-top: 6px;

            @include lg {
                display: none;
                margin: 0;
            }
        }
    }
}
</style>
